import { render, staticRenderFns } from "./Toolbar.vue?vue&type=template&id=826c5ba2&scoped=true&"
import script from "./Toolbar.vue?vue&type=script&lang=js&"
export * from "./Toolbar.vue?vue&type=script&lang=js&"
import style0 from "./Toolbar.vue?vue&type=style&index=0&id=826c5ba2&scoped=true&lang=sass&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "826c5ba2",
  null
  
)

/* custom blocks */
import block0 from "./Toolbar.vue?vue&type=custom&index=0&blockType=i18n&lang=yaml"
if (typeof block0 === 'function') block0(component)

/* hot reload */
if (module.hot) {
  var api = require("/home/circleci/project/client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('826c5ba2')) {
      api.createRecord('826c5ba2', component.options)
    } else {
      api.reload('826c5ba2', component.options)
    }
    module.hot.accept("./Toolbar.vue?vue&type=template&id=826c5ba2&scoped=true&", function () {
      api.rerender('826c5ba2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/GalleryView/Toolbar/Toolbar.vue"
export default component.exports